import { Outlet } from 'react-router-dom';
import MainNavigation from '../components/MainNavigation';
import RootUI from './RootUI';

import './Root.scss';
import OnboardingTour from '../components/ui/OnboardingTour';
import Chatbot from './ChatbotComp';

function RootLayout() {
	return (
		<>
			<MainNavigation />
			<main className='main-content'>
				<Chatbot />
				<Outlet />
			</main>
			<RootUI />
			<OnboardingTour />
		</>
	);
}

export default RootLayout;
